<template>
  <div
    class="bg-bottom bg-no-repeat bg-cover h-full mx-auto"
    :style="
      'background-image: url(' +
      require('@/assets/images/contact/bg.jpg') +
      ');'
    "
  >
    <div class="w-full shadow-lg mb-8">
      <img src="@/assets/images/contact/title-bar.jpg" />
    </div>
    <div class="mx-6 flex flex-col items-center justify-center">
      <div class="text-lg  mb-8">
        欢迎访问medmix迈德米斯微官网
      </div>
      <div
        class="w-full mb-2 bg-white border-t-4 border-blue-400 rounded shadow-lg hover:bg-gray-100"
      >
        <div class="flex items-center">
          <div class="flex-no-grow px-4 my-4 border-r border-gray-500">
            <svg
              class="text-gray-500 w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          </div>
          <div class="flex-grow px-4 my-4  text-sm">
            上海市闵行区北斗路 68 号
          </div>
          <div class="flex-no-grow px-4 my-4">
            <svg
              class="text-gray-400 w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            ></svg>
          </div>
        </div>
      </div>
      <div
        class="w-full mb-2 bg-white border-t-4 border-blue-400 rounded shadow-lg hover:bg-gray-100"
      >
        <div class="flex items-center">
          <div class="flex-no-grow px-4 my-4 border-r border-gray-500">
            <svg
              class="text-gray-500 w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
          </div>
          <div class="flex-grow px-4 my-4  text-sm">
            <a href="mailto:sales.industry@medmix.com"
              >sales.industry@medmix.com</a
            >
          </div>
          <div class="flex-no-grow px-4 my-4">
            <svg
              class="text-gray-400 w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            ></svg>
          </div>
        </div>
      </div>
      <a
        href="tel:02164306868"
        class="w-full px-6 py-3 my-4 bg-blue-900 text-white rounded flex items-center justify-center"
      >
        <svg
          class="w-4 h-4 mr-2 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
          />
        </svg>
        <span>联系电话</span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "hello",
  data() {
    return {};
  },
};
</script>
<style scoped>
.bg-blue-900 {
  background-color: rgb(253, 167, 55);
}
.text-blue-800{
  /* color: rgb(253, 167, 55); */
  color: gray;

}
</style>
